import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";

function QueueDetailButton({ isMobile, ...props }) {
  const { t } = useTranslation("Shared");

  return (
    <Button size="sm" variant="outline-primary" {...props}>
      {isMobile ? <FontAwesomeIcon icon={Icons.arrowRight} /> : t("details")}
    </Button>
  );
}

export default memo(QueueDetailButton);
